/**
 * 链接打开时的appProps
 */
let _appProps;

export function setAppProps(props) {
    _appProps = props;
}

export function getAppProps() {
    return _appProps || {};
}
